module.exports = __webpack_public_path__ + "static/media/ninx9.7eadbefe.jpg";